import React, { useEffect, useState } from "react";
import { Box, Card, Typography, Chip } from "@mui/material";
import { toLocalTime } from "../../helper/functions";
import dayjs from "dayjs";

const OrderCountdownTimer = ({ order, orderItems }) => {
  const [timeRemaining, setTimeRemaining] = useState("");
  const [isLive, setIsLive] = useState(true);

  useEffect(() => {
    const updateCountdown = (inter) => {
      const now = new Date();
      const diffMs =
        new Date(order.orderExpirationTime).getTime() - now.getTime();

      if (diffMs <= 0 || !order.orderExpirationTime) {
        setTimeRemaining("00:00:00");
        setIsLive(false);
        if (inter) {
          clearInterval(inter);
        }
        return;
      }

      setIsLive(true);

      const totalSeconds = Math.floor(diffMs / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const timeString = `${String(hours).padStart(2, "0")}:${String(
        minutes,
      ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

      setTimeRemaining(timeString);
    };

    const interval = setInterval(() => updateCountdown(interval), 1000);

    return () => clearInterval(interval);
  }, [order.orderExpirationTime]);

  // Get the first pickup start time
  const pickupStartTime = order.orderHistory.find(
    (hist) => hist.status === "Pickup P1 Started",
  )?.timestamp;

  return (
    <Card
      sx={{
        padding: "20px 24px",
        borderRadius: "12px",
        backgroundColor: "#FFFFFF",
        border: "1px solid #E0E0E0",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        marginBottom: "20px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        {/* Left Section - Timer Info */}
        <Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
            <Box
              sx={{
                width: "16px",
                height: "16px",
                borderRadius: "50%",
                backgroundColor: "#1ACA6D",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            />
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#2C2C2C",
              }}
            >
              Order Countdown Timer
            </Typography>
          </Box>
        </Box>
        <Chip
          label={isLive ? "Live" : "Time Out"}
          sx={{
            backgroundColor: isLive ? "#E8F5E9" : "#f39b9b92",
            color: isLive ? "#1ACA6D" : "#990000",
            fontWeight: 600,
            fontSize: "12px",
            marginBottom: "16px",
            "& .MuiChip-label": {
              padding: "6px 12px",
            },
          }}
          icon={
            <Box
              sx={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: isLive ? "#1ACA6D" : "#990000",
                ml: 1,
              }}
            />
          }
        />

        {/* Right Section - Status and Pickup Time */}
      </Box>
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        position={"relative"}
        width={"100%"}
      >
        <Box>
          <Typography
            sx={{
              fontSize: "12px",
              color: "#000000",
              fontWeight: 600,
            }}
          >
            Time on {order?.orderId}
          </Typography>

          <Typography
            sx={{
              fontSize: "48px",
              fontWeight: 700,
              color: "#2C2C2C",
              fontFamily: "monospace",
              letterSpacing: "2px",
            }}
          >
            {timeRemaining || "00:00:00"}
          </Typography>
        </Box>
        <Box position={"absolute"} ml="50%">
          <Typography
            sx={{
              fontSize: "12px",
              color: "#000000",
              marginBottom: "4px",
              fontWeight: 600,
            }}
          >
            Pickup Started
          </Typography>

          <Typography
            sx={{
              fontSize: "13px",
              fontWeight: 500,
              color: "#2C2C2C",
            }}
          >
            {pickupStartTime
              ? toLocalTime(new Date(pickupStartTime), "D MMM YYYY, h:mm A")
              : "Not Available"}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};

export default OrderCountdownTimer;
